__webpack_require__.p = "/lrt-vocab/";